<template>
  <div class="root">
    <div class="header">
      <div class="title">
        <div class="title-pointer" :style="`--bg: ${color}`"></div>
        <span class="title-text">{{ name }}</span>
      </div>
      <div class="value">
        <span style="font-weight: bold">{{ value }}</span>
        <span>{{ unit }}</span>
      </div>
    </div>

    <div class="body">
      <slot></slot>
    </div>

  </div>

</template>



<script setup>
const props = defineProps({
  name: {
    type: String
  },
  value: {
    type: String
  },
  unit: {
    type: String
  },
  color: {
    type: String
  }
})



</script>


<style>
.root {
  background: #4c526b60;
  margin-top: 8px;
  padding: 8px;
  border-radius: 4px;
}

.header,
.title {
  display: flex;
  align-items: center;
}

.header {
  justify-content: space-between;
}

.body {
  color: var(--color-text-secondary);
}

.value {
  color: var(--color-text);
  margin-left: 16px;
}

.title-pointer {
  width: 8px;
  height: 8px;
  border-radius: 50%;
  background: var(--bg, #fff);
  margin-right: 8px;
}
</style>
